import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { Button, ThemeStyle } from '@treelab/panda';

import { GLYPHS } from '../../../../../constants/icons';

import { IDispatch } from '../../../../../modules/stores';

import { BtnMixin } from './styled';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  spaceId: string;
}

const DuplicateBtn: React.FC<IProps> = ({
  spaceId,
  duplicateSpace,
  intl: { formatMessage },
}: IProps) => (
  <Button
    buttonType="text"
    onClick={() => duplicateSpace(spaceId)}
    css={BtnMixin}
    icon={GLYPHS.DUPLICATE}
    iconSize={{ height: 14, width: 14 }}
    colorTheme={ThemeStyle.white}
  >
    {formatMessage({ id: 'sidebar.button.duplicate' })}
  </Button>
);

const mapDispatch = ({ space }: IDispatch) => ({
  duplicateSpace: (spaceId: string) => space.duplicateSpace(spaceId),
});

export default compose(
  injectIntl,
  connect(
    () => ({}),
    // @ts-ignore
    mapDispatch,
  ),
)(DuplicateBtn);
